module.exports = __webpack_public_path__ + "img/safety_precautions.28ad1429.png";